import { MantineThemeOverride } from '@mantine/core';
import { clsx } from 'clsx';

export const getCustomThemeOverrides = (): MantineThemeOverride => ({
    components: {
        Table: {
            classNames: {
                table: 'text-left w-full',
                th: clsx`text-base-bold p-2 first:pl-0 last:pr-0`,
                td: clsx`p-2 text-base first:pl-0 last:pr-0`,
                tr: clsx`border-b-border-disabled border-b`,
            },
        },
        InputBase: {
            defaultProps: {
                unstyled: true,
            },
            // classNames: classNames.textField.default,
        },
    },
});
